module.exports = __webpack_public_path__ + "img/verloop-sample-chat.3aa41c0d.jpg";